//#region lib/Factbox/lib/formatDate.ts
var e = (e, t) => {
	if (!e) return "";
	let n = Number(new Date(e)), r = Math.round((n - Date.now()) / 1e3), i = [
		60,
		3600,
		86400,
		604800,
		2592e3,
		31536e3,
		Infinity
	], a = [
		"second",
		"minute",
		"hour",
		"day",
		"week",
		"month",
		"year"
	], o = i.findIndex((e) => e > Math.abs(r)), s = o ? i[o - 1] : 1;
	return new Intl.RelativeTimeFormat(t || "en", { numeric: "auto" }).format(Math.floor(r / s), a[o]);
}, t = (e) => {
	if (!e) return "";
	let t = new Date(e);
	return isNaN(t.getTime()) ? "" : new Intl.DateTimeFormat("sv-SE", {
		year: "numeric",
		month: "2-digit",
		day: "2-digit",
		hour: "2-digit",
		minute: "2-digit"
	}).format(t);
};
//#endregion
export { e as formatDate, t as formatDateShort };
